import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, } from "@mui/material";
import { Form, Formik } from "formik";
import FormikActions from "../../../../../../../../../commons/formik/FormikActions";
import FormikDateTimePicker from "../../../../../../../../../commons/formik/FormikDateTimePicker";
import FormikTextField from "../../../../../../../../../commons/formik/FormikTextField";
import { StyledResolucion } from "../../../../../../../../../styled/Prevencion";
import { validateResponsableInstalacionForm } from "../../../../../formValidations";

const ResponsableInstalacionForm = ({ open, handleClose, handleSubmit, values }) => {
    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogTitle>Administrar Responsable de Instalación</DialogTitle>
            <Formik
                initialValues={values}
                onSubmit={(values) => handleSubmit(values)}
                validationSchema={validateResponsableInstalacionForm}
            >
                {() => (
                    <Form>
                        <DialogContent>
                            <Grid container >
                                {/* Cuil del Responsable */}
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikTextField
                                        name="cuitResponsable"
                                        label="CUIL del Responsable *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Nro. Licencia Habilitante */}
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikTextField
                                        name="numeroLicenciaHabilitante"
                                        label="Nro. Licencia Habilitante *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Domicilio de Habilitación */}
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikTextField
                                        name="domicilioHabilitacion"
                                        label="Domicilio de Habilitación"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Fecha de Expedición */}
                                <StyledResolucion.DialogGridItem item xs={6}>
                                    <FormikDateTimePicker
                                        name="fechaExpedicion"
                                        label="Fecha de Expedición *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Fecha de Vencimiento */}
                                <StyledResolucion.DialogGridItem item xs={6}>
                                    <FormikDateTimePicker
                                        name="fechaVencimiento"
                                        label="Fecha de Vencimiento *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <FormikActions handleCancel={handleClose} />
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default ResponsableInstalacionForm;
